import { render, staticRenderFns } from "./CategoryCard.vue?vue&type=template&id=1a3759df&scoped=true&"
import script from "./CategoryCard.vue?vue&type=script&lang=ts&"
export * from "./CategoryCard.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryCard.vue?vue&type=style&index=0&id=1a3759df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3759df",
  null
  
)

export default component.exports